import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION_TYPE_OPTION_IDS } from 'commons/constants';
import JBImage from 'components/essentials/JBImage';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import usePDPOptions from '../state/context/usePDPOptions';

// Selected fabric and orientation, shared by the desktop and mobile summary bars
const PDPStickySummaryOptions = t0 => {
  const $ = _c(17);
  const {
    slug,
    className
  } = t0;
  const {
    data: t1
  } = usePDPOptions();
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    selectedOptionsExtended: t3
  } = t2;
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const selectedOptionsExtended = t4;
  const {
    data: t5
  } = usePDPFabricFilters(slug);
  const {
    selectedMaterial
  } = t5;
  let t6;
  if ($[4] !== selectedOptionsExtended) {
    t6 = ORIENTATION_TYPE_OPTION_IDS.map(optionId => selectedOptionsExtended?.[optionId]?.value?.value).find(Boolean);
    $[4] = selectedOptionsExtended;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const orientationLabel = t6;
  const fabricLabel = selectedMaterial?.label || selectedMaterial?.value;
  if (!fabricLabel && !orientationLabel) {
    return null;
  }
  let t7;
  if ($[6] !== className) {
    t7 = classNames("flex gap-8 text-sm text-gray", className);
    $[6] = className;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== fabricLabel || $[9] !== selectedMaterial) {
    t8 = fabricLabel && <div><div className="text-gray-light2">Fabric:</div><div className="flex items-center gap-2 font-bold" data-xc="PDPStickySummaryFabric">{selectedMaterial.image && <JBImage src={selectedMaterial.image} width="20" height="20" className="h-5 w-5 rounded-full object-cover" />}{fabricLabel}</div>{!!selectedMaterial.pet_friendly && <div className="text-xs text-gray-light2">(Pet Friendly)</div>}</div>;
    $[8] = fabricLabel;
    $[9] = selectedMaterial;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== orientationLabel) {
    t9 = orientationLabel && <div><div className="text-gray-light2">Orientation:</div><div className="font-bold">{orientationLabel}</div></div>;
    $[11] = orientationLabel;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
PDPStickySummaryOptions.propTypes = {
  slug: PropTypes.string,
  className: PropTypes.string
};
export default PDPStickySummaryOptions;